module.exports = __webpack_public_path__ + "static/media/rate-4.46b3bbd3.svg";